// extracted by mini-css-extract-plugin
export default {"contents":"healthalertpanel_contents__oKAve","item":"healthalertpanel_item__wbKiS","title":"healthalertpanel_title__qAxTF","value":"healthalertpanel_value__fGKBU"};